/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6e510f6c-b594-424d-9034-7d62cd05e92d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_0DmOYVkYc",
    "aws_user_pools_web_client_id": "74duv76bm1ngspoqk8uf2gqado",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],

    // 🔽 Add this block for S3
    "Storage": {
        "AWSS3": {
            "bucket": "my-transcribe-audio-uploads",  // 🔁 Replace with your actual S3 bucket name
            "region": "us-east-1"
        }
    }
};

export default awsmobile;

